<section class="flex flex-col m-2.5 grow">
    <app-management-list-header
        [actionEnabled]="hasRemainingLicenses() && canCreateUser()"
        [subtitle]="
            `${usersWithLicensesToDisplay() ? paginatedPeople()!.totalItems : 0} ${('user' | transloco: { COUNT: usersWithLicensesToDisplay() ? paginatedPeople()!.totalItems : 0 })}`
                | lowercase
        "
        [title]="'user' | transloco"
        (actionClicked)="openCreateUserModal()"
        (search)="searchUsers($event)" />
    @if (usersWithLicensesToDisplay()) {
        <app-custom-table
            class="m-2 flex-1 min-h-0 overflow-auto"
            [columns]="tableColumns"
            (sortEvent)="onSortChange($event)">
            @for (user of usersWithLicensesToDisplay(); track user.id) {
                <tr
                    [class.selectedUser]="user.id === userInPanel()"
                    (click)="onUserToggle(user)">
                    <td>
                        {{ user.familyName }}
                    </td>
                    <td>
                        {{ user.givenName }}
                    </td>
                    <td>
                        {{ user.email }}
                    </td>
                    <td>
                        @if (rolesById() && user.role !== null && rolesById()![user.role]) {
                            {{ rolesById()![user.role].name }}
                        } @else {
                            -
                        }
                    </td>
                    <td class="!py-0">
                        @for (license of user.licenses; track license) {
                            <app-logo
                                logoClasses="w-6 px-1"
                                [application]="license"
                                [matTooltip]="license" />
                        }
                    </td>
                </tr>
            }
        </app-custom-table>

        <app-paginator
            #paginator
            [take]="paginatedPeople()!.take"
            [totalItems]="paginatedPeople()!.totalItems"
            (onPageChange)="onPaginationChange($event)" />
    } @else {
        <app-no-data-to-display
            displayedMessage="noUsersFound"
            iconSize="5x" />
    }
</section>
